import script from "./ProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=c53b0452&lang=css"

const __exports__ = script;

export default __exports__